import { store } from '@/store'
import DynamicModuleRegistrationUtil from '@/utils/dynamicModuleRegistration'
import { BaseRouteEnum, IntegrationsEnum } from '@/enums/modules/routes'
import platformSupportDefinitions from '../components/integrations/Management/platformSupportDefinitions'
import TokenManagementRoot from '../components/micro-front-ends/TokenManagement'

// Vuex Modules to load
const IntegrationsModule = () => import(/* webpackChunkName: "Integrations" */ '../store/modules/integrations')

// Components
const IntegrationsPlaceholder = () =>
  import(/* webpackChunkName: "Integrations" */ '@/components/integrations/IntegrationsPlaceholder')

const Integrations = () =>
  import(/* webpackChunkName: "Integrations" */ '@/components/integrations/Integrations')

const IntegrationsManagementPlaceholder = () =>
  import(/* webpackChunkName: "Integrations" */ '@/components/integrations/Management/IntegrationsManagementPlaceholder')

const IntegrationManagement = () =>
  import(/* webpackChunkName: "IntegrationsManagement" */ '@/components/integrations/Management/IntegrationManagement')

const IntegrationListings = () =>
  import(/* webpackChunkName: "Integrations" */ '@/components/integrations/Management/IntegrationListings')

const dynamicModuleRegistrationReturnsArgs = () => {
  return {
    modulesNamespace: store._modulesNamespaceMap,
    moduleName: 'integrations',
    module: IntegrationsModule,
    store,
    modulePath: 'integrations'
  }
}

export default [
  {
    path: '/Integrations',
    component: IntegrationsPlaceholder,
    name: IntegrationsEnum.Integrations,
    beforeEnter (_to, _from, next) {
      // eslint-disable-next-line dot-notation
      const vueIntegrationsFeatureFlag = store.getters['enableVueIntegrations']
      if (vueIntegrationsFeatureFlag) {
        DynamicModuleRegistrationUtil(dynamicModuleRegistrationReturnsArgs()).then(() => next())
      } else {
        next({ name: BaseRouteEnum.FourOhFour })
      }
    },
    meta: { domain: IntegrationsEnum.Integrations },
    children: [
      {
        path: '',
        redirect: 'Store'
      },
      {
        path: 'Store',
        component: Integrations,
        name: IntegrationsEnum.Store,
        meta: { showSideNav: true },
        props: {
          myApps: false
        }
      },
      {
        path: 'MyApps',
        component: Integrations,
        name: IntegrationsEnum.MyApps,
        meta: { showSideNav: true },
        props: {
          myApps: true
        }
      },
      {
        path: 'token-management*',
        component: TokenManagementRoot,
        name: 'TokenManagementUi',
        beforeEnter (to, from, next) {
          // if a subaccount user of a powered by account tries to load token-management information
          // redirect them to the Dashboard instead
          const { isPoweredBySubAccountUser } = store.getters['user/getExternalIdInfo']
          if (isPoweredBySubAccountUser) {
            next({ name: BaseRouteEnum.DashboardV2 })
          } else {
            next()
          }
        },
        meta: { showSideNav: true }
      },
      {
        path: 'app-management*',
        component: TokenManagementRoot,
        name: 'TokenManagementUi',
        beforeEnter (to, from, next) {
          // if a subaccount user of a powered by account tries to load app-management information
          // redirect them to the Dashboard instead
          const { isPoweredBySubAccountUser } = store.getters['user/getExternalIdInfo']
          if (isPoweredBySubAccountUser) {
            next({ name: BaseRouteEnum.DashboardV2 })
          } else {
            next()
          }
        },
        meta: { showSideNav: true }
      },
      {
        path: 'webhooks*',
        component: TokenManagementRoot,
        name: 'TokenManagementUi',
        beforeEnter (to, from, next) {
          // if a subaccount user of a powered by account tries to load app-management information
          // redirect them to the Dashboard instead
          const { isPoweredBySubAccountUser } = store.getters['user/getExternalIdInfo']
          if (isPoweredBySubAccountUser) {
            next({ name: BaseRouteEnum.DashboardV2 })
          } else {
            next()
          }
        },
        meta: { showSideNav: true }
      }
    ]
  },
  {
    path: '/IntegrationsManagement',
    component: IntegrationsManagementPlaceholder, // IntegrationListings,
    beforeEnter (_to, _from, next) {
      // eslint-disable-next-line dot-notation
      const newFlowFeatureFlag = store.getters['enableNewShopifySettingsUI']
      if (newFlowFeatureFlag) {
        DynamicModuleRegistrationUtil(dynamicModuleRegistrationReturnsArgs()).then(() => next())
      } else {
        // redirect to QuickSetup if not on feature flag
        if (_to.query.platformSource === 'shopify' && _to.query.newInstall === 'true') {
          window.location = '/Home/QuickSetup?=shopifyLinkFulfillmentService'
        } else {
          window.location = '/Home/QuickSetup'
        }
      }
    },
    children: [
      {
        path: '',
        component: IntegrationListings,
        meta: { showSideNav: true },
        name: IntegrationsEnum.IntegrationListings,
        beforeEnter (_to, _from, next) {
          if (!_to.query.platformSource) {
            _to.query.platformSource = 'shopify'
          }

          const platformName = _to.query.platformSource.toLowerCase()
          const platformDefined = platformSupportDefinitions[platformName]
          if (platformDefined) {
            DynamicModuleRegistrationUtil(dynamicModuleRegistrationReturnsArgs()).then(() => next())
          } else {
            next({ name: BaseRouteEnum.FourOhFour })
          }
        },
        props: (route) => ({
          platformSource: route.query.platformSource,
          editable: false
        })
      },
      {
        path: ':integrationId',
        component: IntegrationManagement,
        name: IntegrationsEnum.IntegrationManagement,
        meta: { showSideNav: true },
        props: (route) => ({
          integrationId: parseInt(route.params.integrationId),
          editable: false
        })
      }
    ]
  }
]
